import React, { useEffect } from 'react'
import { func, object, bool, string } from 'prop-types'

import { trackEvent, trackQueryParam, untrackQueryParam } from 'utils/tracking'
import Modal from 'components/Modal'
import SignupForm from 'components/SignupForm'
import useDigitalData from 'hooks/useDigitalData'

const SignUpModal = ({ visible, close = () => {}, ...rest }) => {
  const { digitalData } = useDigitalData()

  useEffect(() => {
    if (!visible) {
      untrackQueryParam('login_popup')
      return
    }

    trackQueryParam('login_popup')

    window.dataObject.time = Date()
    trackEvent({
      name: 'modalLogin',
      time: Date()
    })
  }, [visible])

  useEffect(() => {
    digitalData.push({
      page: {
        virtualUrl: location.pathname + '/signup-modal',
        timestamp: new Date().getTime()
      }
    })
  }, [])

  return (
    <Modal visible={visible} wide hasWhiteClose close={close}>
      <SignupForm closeModal={close} {...rest} />
    </Modal>
  )
}

SignUpModal.propTypes = {
  router: object,
  close: func,
  visible: bool,
  handleSubmit: func.isRequired,
  handleChange: func.isRequired,
  handleBlur: func.isRequired,
  values: object.isRequired,
  errors: object.isRequired,
  touched: object.isRequired,
  isSubmitting: bool.isRequired,
  handleUserSignup: func.isRequired,
  setFieldValue: func.isRequired,
  setErrors: func.isRequired,
  setFieldError: func.isRequired,
  resetForm: func.isRequired,
  signupError: string,
  setLoginModalVisibility: func.isRequired,
  utmCampaign: string,
  utmSource: string,
  utmMedium: string
}

export default SignUpModal
